export default __webpack_public_path__ + "static/use_case_creation-a8bf556d338c08513f7406e76952be83.gif";